<template>
    <div>
        <div class="vx-col w-full sm:w-auto">
            <p class="font-semibold text-lg">Device Transaction Summary</p>
            <small>{{datestring}}</small>
            <vs-divider/>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span class="font-semibold text-md">Merchant</span>
                </div>
                <div class="vx-col sm:w-2/5 w-full">
                    {{details.merchant}}
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span class="font-semibold text-md">Device Code</span>
                </div>
                <div class="vx-col sm:w-2/5 w-full">
                    {{details.devicecode}}
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span class="font-semibold text-md">Status</span>
                </div>
                <div class="vx-col sm:w-2/5 w-full" :class="details.statusclass">
                    {{details.statustext}}
                </div>
            </div>
            <div class="vx-row mb-6" v-if="details.summaryavail">
                <div class="vx-col sm:w-1/6 w-full">
                    <span class="font-semibold text-md">Summary success</span>
                </div>
                <div class="vx-col sm:w-2/5 w-full">
                    {{details.trxsuccess}} transaction(s)
                </div>
            </div>
            <div class="vx-row mb-6" v-if="details.summaryavail">
                <div class="vx-col sm:w-1/6 w-full">
                    <span class="font-semibold text-md">Summary failed</span>
                </div>
                <div class="vx-col sm:w-2/5 w-full">
                    {{details.trxfailed}} transaction(s)
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span class="font-semibold text-md">Actual transaction</span>
                </div>
                <div class="vx-col sm:w-2/5 w-full">
                    {{details.actual}} transaction(s)
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                    <span class="font-semibold text-md">Last Sent Device Transaction</span>
                </div>
                <div class="vx-col sm:w-2/5 w-full">
                    {{details.updateTimestamp}}
                </div>
            </div>
        </div>
        <vs-divider/>
        <ag-grid-vue
            :gridOptions="gridOptions"
            class="ag-theme-material w-100 my-4 ag-grid-table"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :rowData="detail"
            rowSelection="multiple"
            colResizeDefault="shift"
            :animateRows="true"
            :floatingFilter="true"
            :pagination="false"
        ></ag-grid-vue>
    </div>
</template>

<script>
    import {AgGridVue} from "ag-grid-vue";
    import AxiosCall from "@/global/AxiosCall";
    import { url } from "@/configs/apiUrl";
    import moment from 'moment'

    export default {
        name: 'DeviceMonitoringDetail',
        components: {
            AgGridVue,
        },
        data() {
            return {
                details :{},
                datestring : "",
                gridOptions: {},
                detail: [],
                columnDefs: [
                    {
                        headerName: "CSN",
                        field: "csn",
                        width: 150,
                        filter: true,
                        cellRenderer: this.nullColumnRenderer
                    },
                    {
                        headerName: "Merchant",
                        field: "merchant_name",
                        width: 200,
                        filter: true,
                        cellRenderer: this.nullColumnRenderer
                    },
                    {
                        headerName: "Payment Channel",
                        field: "payment_channel_name",
                        width: 200,
                        filter: true,
                        cellRenderer: this.nullColumnRenderer
                    },
                    {
                        headerName: "Amount",
                        field: "amount",
                        width: 150,
                        cellRenderer: this.nullColumnRenderer
                    },
                    {
                        headerName: "Type",
                        field: "transaction_type",
                        width: 180,
                        filter: true,
                        cellRenderer: this.nullColumnRenderer
                    },
                    {
                        headerName: "Trx UUID",
                        field: "uuid_trx",
                        filter: true,
                        cellRenderer: this.nullColumnRenderer
                    },
                ],
                defaultColDef: {
                    sortable: true,
                    editable: false,
                    resizable: true,
                    suppressMenu: true,
                },
            }
        },
        computed: {
        },
        created: function() {

        },
        methods:{
            openLoading(){
                this.$vs.loading({
                    type: 'default',
                })
            },
        },
        beforeMount(){
        },
        mounted() {
            this.details["summaryavail"] = (this.$route.query.status !== 'WARNING') ? true : false
            this.details["devicecode"] = this.$route.query.devicecode
            this.details["merchant"] = this.$route.query.merchant.replaceAll("%", " ")
            this.details["trxsuccess"] = this.$route.query.trxsuccess
            this.details["trxfailed"] = this.$route.query.trxfailed
            this.datestring = moment(this.$route.query.date, "YYYY-MM-DD").format("dddd, MMMM Do YYYY")
            this.details["updateTimestamp"] = this.$route.query.updateTimestamp.replaceAll("%", " ")

            if(this.$route.query.devicecode !== "" && this.$route.query.date !== "" && this.$route.query.merchantcode !== ""){
                this.openLoading()
                AxiosCall.Get(url.device_trxn_summary.detail+"?devicecode="+this.$route.query.devicecode+"&date="+this.$route.query.date+"&merchantcode="+this.$route.query.merchantcode).then(resp =>{
                    this.$vs.loading.close()
                    this.detail = resp.data
                    this.details["actual"] = this.detail.length
                    this.details["trxIsMatch"] = ( (parseInt(this.$route.query.trxsuccess) + parseInt(this.$route.query.trxfailed)) == this.detail.length ) ? true : false
                    this.details["statustext"] = this.details["summaryavail"] ? ( this.details["trxIsMatch"] ? (this.$route.query.status === "NO_SUMMARY") ? "No summary data in server and device " : "Summary data matches transaction data" : "Summary data does not match with transaction data" ) : "Device does not send summary data"
                    this.details["statusclass"] = this.details["summaryavail"] ? ( this.details["trxIsMatch"] ? (this.$route.query.status === "NO_SUMMARY") ? "text-primary" : "text-success" : "text-warning" ) : "text-danger"
                }).catch(e=>{
                    this.$vs.loading.close()
                    this.danger("Failed", "Failed get data."+e)
                })
            }
        }
    }
</script>

